/**
 * Centralized API URL configuration.
 * Priority: 1) VITE_API_URL from .env.production  2) hostname detection
 */
const envUrl = import.meta.env.VITE_API_URL as string | undefined;

const isLocalDev = typeof window !== 'undefined' && (
  window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'
);

export const API_URL = (
  envUrl || (isLocalDev ? 'http://localhost:3000' : 'https://api.nipsys.com')
).replace(/\/+$/, '');
